<div class="tt-w-dim-teaser" :lang="lang">
  <div v-for="dimConfig in subdims" class="tt-w-dim-teaser__item">
    <tt-summary-custom-rating v-if="dimConfig.displayType === 'VISUAL' && dimConfig.dim.type === 1"
                             class="tt-w-dim-teaser__dim"
                             :averageRating="dimConfig.dim.average"
                             :headingLevel="teaserConfig.headingLevel"
                             :label="dimConfig.label">
      <span class="tt-w-dim-teaser__heading-txt">{{dimConfig.label}} {{dimConfig.rating}}</span>
      <a class="tt-w-dim-teaser__reviews-count" href="#tt-reviews-list" @click="toReviews" v-html="dimConfig.numReviewsMsg"></a>
    </tt-summary-custom-rating>
    <tt-summary-custom-range v-if="dimConfig.displayType === 'VISUAL' && dimConfig.dim.type === 2"
                             class="tt-w-dim-teaser__dim"
                             :averageRating="dimConfig.dim.average"
                             :headingLevel="teaserConfig.headingLevel"
                             :showMiddleLabel="true"
                             :values="dimConfig.dim.values">
      <span class="tt-w-dim-teaser__heading-txt">{{dimConfig.label}}</span>
      <a class="tt-w-dim-teaser__reviews-count" href="#tt-reviews-list" @click="toReviews" v-html="dimConfig.numReviewsMsg"></a>
    </tt-summary-custom-range>
    <tt-dim-distribution  v-if="dimConfig.displayType === 'DISTRIBUTION' && dimConfig.dim.type === 2"
                          class="tt-w-dim-teaser__dim"
                          :headingLevel="teaserConfig.headingLevel"
                          :showMiddleLabel="true"
                          :label="dimConfig.label"
                          :values="dimConfig.dim.values">
      <span class="tt-w-dim-teaser__heading-txt">{{dimConfig.label}}</span>
      <a class="tt-w-dim-teaser__reviews-count" href="#tt-reviews-list" @click="toReviews" v-html="dimConfig.numReviewsMsg"></a>
    </tt-dim-distribution>
    <div v-if="dimConfig.displayType === 'TEXT'" class="tt-w-dim-teaser__dim tt-c-dim-text tt-u-spacing--left--xs">
      <span class="tt-c-dim-text__label" v-html="dimConfig.label"></span>
      <span class="tt-c-dim-text__value-label" v-html="dimConfig.valueLabel"></span>
      <span class="tt-c-dim-text__see-all"><a class="tt-c-dim-text__see-all-link" href="#tt-reviews-list" @click="toReviews" v-html="$msg('dimTeaser.seeAll')"></a></span>
    </div>
  </div>
</div>
